import {
    ConditionType,
    PreCondition,
    PostCondition,
    CONDITION_TYPES,
    ConditionRule
} from '@nexxt/common/types';

export const defaultCondition = (
    type: ConditionType
): PreCondition | PostCondition => {
    if (type === CONDITION_TYPES.PRECONDITION) {
        return {
            conditionID: 0,
            isEdit: true,
            new: true,
            rules: []
        };
    } else {
        return {
            conditionID: 0,
            destinationQ: null,
            isEdit: true,
            new: true,
            rules: []
        };
    }
};

export const defaultRules = (): ConditionRule => {
    return {
        compareNumber: null,
        compareOptions: null,
        compareQuestion: null,
        compareType: CONDITION_TYPES.REFERENCE_OPTION,
        compareValueOptions: null,
        ruleID: 0,
        new: true,
        selectedOperator: null,
        selectedReferenceQ: null
    };
};

export const defaultOptionCondition = () => ({
    conditionID: 0,
    isEdit: true,
    new: true,
    rules: [defaultRules()]
});
